module.exports = __webpack_public_path__ + "static/media/unificacao-cadastros.500c7ca0.gif";